import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import Loader from '../utils/loader'

import * as cornerstone from "cornerstone-core"
import * as cornerstoneMath from "cornerstone-math"
import * as cornerstoneTools from "cornerstone-tools"
import Hammer from "hammerjs";
import * as cornerstoneWADOImageLoader from "cornerstone-wado-image-loader"
import * as dicomParser from "dicom-parser"

import { withStyles } from '@material-ui/core/styles'
import { Button, Grid, GridList, Paper, GridListTile, Hidden, Typography } from '@material-ui/core'
import "../styles/dicom-view.css"

function getBlobUrl(url) {
    const baseUrl = window.URL || window.webkitURL;
    const blob = new Blob([`importScripts('${url}')`], {
        type: "application/javascript"
    });

    return baseUrl.createObjectURL(blob);
}

let webWorkerUrl = getBlobUrl(
    "https://unpkg.com/cornerstone-wado-image-loader@2.2.3/dist/cornerstoneWADOImageLoaderWebWorker.min.js"
)

let codecsUrl = getBlobUrl(
    "https://unpkg.com/cornerstone-wado-image-loader@2.2.3/dist/cornerstoneWADOImageLoaderCodecs.js"
)

const config = {
    webWorkerPath: webWorkerUrl,
    taskConfiguration: {
        decodeTask: {
            codecsPath: codecsUrl
        }
    }
};

const styles = theme => ({
    root: {
        color: 'inherit',
        fontFamily: 'Montserrat',
        display: 'flex'
    }
});

class DicomViewer extends Component {
    constructor(props){
        super(props);

        this.state = {
            stack: JSON.parse(sessionStorage.getItem("examlist")),
            viewport: cornerstone.getDefaultViewport(null, undefined),
            imageId: JSON.parse(sessionStorage.getItem("examlist"))[0],            
            thumbArray: JSON.parse(sessionStorage.getItem("thumblist")),
            currentTool: 0,
            isLoading: true
        }

        this.onImageRendered = this.onImageRendered.bind(this);
        this.onNewImage = this.onNewImage.bind(this);
        this.onWindowResize = this.onWindowResize.bind(this);
        this.toggleSaturation = this.toggleSaturation.bind(this);
        this.togglePan = this.togglePan.bind(this);
        this.toggleZoom = this.toggleZoom.bind(this);
        this.toggleLength = this.toggleLength.bind(this);
        this.toggleProbe = this.toggleProbe.bind(this);
        this.toggleEllipse = this.toggleEllipse.bind(this);
        this.toggleRectangle = this.toggleRectangle.bind(this);
        this.toggleAngle = this.toggleAngle.bind(this);
        this.toggleHighlight = this.toggleHighlight.bind(this);
        this.refreshPage = this.refreshPage.bind(this);
    }

    render() {
        return (
            <Fragment>
                <Loader active={this.state.isLoading}/>
                <Grid container className='dicom-background'>
                    <Grid item container sm={3} md={2} lg={1} direction='column' alignItems='flex-start' wrap='wrap'> 
                        <Hidden xsDown>
                                <Paper className='avatar-paper'>
                                    <Typography
                                        className='title'
                                        align='center'
                                        type='title'>
                                        CedimTech
                                    </Typography>
                                    </Paper>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 1)}
                                        onClick={this.toggleSaturation}>
                                        Saturação
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 2)}
                                        onClick={this.togglePan}>
                                        Mover
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 3)}
                                        onClick={this.toggleZoom}>
                                        Zoom
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 4)}
                                        onClick={this.toggleLength}>
                                        Comprimento
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 5)}
                                        onClick={this.toggleProbe}>
                                        Ponto
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 6)}
                                        onClick={this.toggleEllipse}>
                                        Elipse
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 7)}
                                        onClick={this.toggleRectangle}>
                                        Retângulo
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 8)}
                                        onClick={this.toggleAngle}>
                                        Ângulo
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        disabled={(this.state.currentTool === 9)}
                                        onClick={this.toggleHighlight}>
                                        Foco
                                    </Button>
                                    <Button 
                                        variant='contained'
                                        className='button'
                                        onClick={this.refreshPage}>
                                        Limpar Tudo
                                    </Button>
                        </Hidden>
                    </Grid>
                    <Grid item container sm={9} md={10} lg={11} justify='center'>
                        <Grid item sm={12}>
                                <Paper className="viewport-background">
                                    <div
                                        id="viewportElement"
                                        ref={input => {
                                            this.element = input;
                                        }}
                                        className='viewport-panel'>
                                    </div>
                                </Paper>
                            </Grid>                         
                        <Grid item container sm={12}>
                            <Paper className='thumb-zone'>
                                <GridList cols={10} cellHeight='auto' className='thumb-scroll'>
                                    {this.state.stack.map((tile, index) =>(
                                        <GridListTile key={index}>
                                            <Button
                                                id={index}
                                                onClick={this.changeImage}>
                                                <img
                                                    className='thumb'
                                                    src={this.state.thumbArray[index]}
                                                    alt={index}/>
                                            </Button>
                                        </GridListTile>
                                    ))}
                                </GridList>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
            </Fragment>
        )
    }

    onWindowResize() {
        cornerstone.resize(this.element);
    }

    onImageRendered() {
        const view = cornerstone.getViewport(this.element);
    
        this.setState({
          viewport: view
        });
    }

    changeImage = (event) => {
        this.setState({currentTool: 0});
        this.disableAllTools();
        this.setState({
            imageId: this.state.stack[event.currentTarget.id],
            isLoading: true
        }, () => {this.loadAndViewImage()})
    }

    showSummary = (event) => {
        let exam = this.props.examList.results.find(currentExam => currentExam.exam_id === event.currentTarget.id )
        this.setState({currentExam : exam})
        this.setState(state => ({ isPatientSelected: !state.isPatientSelected}))
    }

    onNewImage() {
        const enabledElement = cornerstone.getEnabledElement(this.element);

        this.setState({
          imageId: enabledElement.image.imageId
        });
    }

    loadAndViewImage() {
        const element = this.element;
        const viewport = cornerstone.getViewport(this.element);
        // Load the first image in the stack
        cornerstone.loadAndCacheImage(this.state.imageId).then(image => {
        // Display the first image
            cornerstone.displayImage(element, image);

            // Add the stack tool state to the enabled element
            const stack = this.state.stack;
            cornerstoneTools.addStackStateManager(element, ["stack"]);
            cornerstoneTools.addToolState(element, "stack", stack);
    
            cornerstoneTools.mouseInput.enable(element);
    
            element.addEventListener(
                "cornerstoneimagerendered",
                this.onImageRendered
            );
            element.addEventListener("cornerstonenewimage", this.onNewImage);
            window.addEventListener("resize", this.onWindowResize);

            this.disableAllTools(element);

            viewport.translation = {x: 0,y: 0}
            viewport.scale = 1;

            this.setState({
                isLoading: false              
            })
        })
    }

    disableAllTools() {
        cornerstoneTools.wwwc.disable(this.element);
        cornerstoneTools.pan.disable(this.element);
        cornerstoneTools.zoom.activate(this.element, 2);
        cornerstoneTools.probe.deactivate(this.element, 1);
        cornerstoneTools.length.deactivate(this.element, 1);
        cornerstoneTools.ellipticalRoi.deactivate(this.element, 1);
        cornerstoneTools.rectangleRoi.deactivate(this.element, 1);
        cornerstoneTools.angle.deactivate(this.element, 1);
        cornerstoneTools.highlight.deactivate(this.element, 1);
        cornerstoneTools.freehand.deactivate(this.element, 1);
    }

    toggleSaturation() {
        this.setState({currentTool: 1});
        this.disableAllTools();
        cornerstoneTools.wwwc.activate(this.element, 1)
    }

    togglePan() {
        this.setState({currentTool: 2});
        this.disableAllTools();
        cornerstoneTools.pan.activate(this.element, 1)
    }

    toggleZoom() {
        this.setState({currentTool: 3});
        this.disableAllTools();
        cornerstoneTools.zoom.activate(this.element, 1)
    }

    toggleLength() {
        this.setState({currentTool: 4});
        this.disableAllTools();
        cornerstoneTools.length.activate(this.element, 1);
    }

    toggleProbe() {
        this.setState({currentTool: 5});
        this.disableAllTools();
        cornerstoneTools.probe.activate(this.element, 1);
    }

    toggleEllipse() {
        this.setState({currentTool: 6});
        this.disableAllTools();
        cornerstoneTools.ellipticalRoi.activate(this.element, 1);
    }

    toggleRectangle() {
        this.setState({currentTool: 7});
        this.disableAllTools();
        cornerstoneTools.rectangleRoi.activate(this.element, 1);
    }

    toggleAngle() {
        this.setState({currentTool: 8});
        this.disableAllTools();
        cornerstoneTools.angle.activate(this.element, 1);
    }

    toggleHighlight() {
        this.setState({currentTool: 9});
        this.disableAllTools();
        cornerstoneTools.highlight.activate(this.element, 1)
    }

    refreshPage() {
        this.setState({currentTool: 0});
        this.disableAllTools();
        window.location.reload();
    }

    componentDidMount() {

        cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
        cornerstoneWADOImageLoader.webWorkerManager.initialize(config);
        cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
        cornerstoneTools.external.cornerstone = cornerstone;
        cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
        cornerstoneTools.external.Hammer = Hammer;

        const element = this.element;
        //const { stack } = this.props.location.state
     
        // Enable the DOM Element for use with Cornerstone
        cornerstone.enable(element);
    
        // Load the first image in the stack
        cornerstone.loadAndCacheImage(this.state.imageId).then(image => {
        // Display the first image
            cornerstone.displayImage(element, image);

            // Add the stack tool state to the enabled element
            const stack = this.state.stack;
            cornerstoneTools.addStackStateManager(element, ["stack"]);
            cornerstoneTools.addToolState(element, "stack", stack);
    
            cornerstoneTools.mouseInput.enable(element);
    
            element.addEventListener(
                "cornerstoneimagerendered",
                this.onImageRendered
            );
            element.addEventListener("cornerstonenewimage", this.onNewImage);
            window.addEventListener("resize", this.onWindowResize);

            this.disableAllTools(element);
            this.setState({
                isLoading: false
            })
        })
    }

    componentWillUnmount() {
        const element = this.element;
        element.removeEventListener(
          "cornerstoneimagerendered",
          this.onImageRendered
        );
    
        element.removeEventListener("cornerstonenewimage", this.onNewImage);
    
        window.removeEventListener("resize", this.onWindowResize);
    
        cornerstone.disable(element);
    }

    componentDidUpdate(prevProps, prevState) {
        const stackData = cornerstoneTools.getToolState(this.element, "stack");
        const stack = stackData.data[0];
        stack.currentImageIdIndex = this.state.stack.currentImageIdIndex;
        stack.imageIds = this.state.stack.imageIds;
        cornerstoneTools.addToolState(this.element, "stack", stack);
    
        // const imageId = stack.imageIds[stack.currentImageIdIndex];
        // cornerstoneTools.scrollToIndex(this.element, stack.currentImageIdIndex);
      }
    
}

function mapStateToProps(state) {
    return { 
    }   
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DicomViewer)));
